import clsx from "clsx";

export default function SvgIcon(props: {children?: any, className?: string, style?: any, onClick?: any}) {
    return (
        <div className={clsx('svg-icon', props.className)} style={props.style} onClick={props.onClick}>{props.children}</div>
    )
}